import { cn } from '@/lib/utils';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

/**
 * Public-page scaffold: sticky Navbar, a growing <main>, and the Footer, in a
 * full-height flex column. Replaces the `min-h-screen flex flex-col` + Navbar +
 * Footer boilerplate repeated across every public page (and each of
 * NewsDetail's loading / not-found / article states).
 */
const PageLayout = ({ children, mainClassName }) => (
  <div className="min-h-screen flex flex-col">
    <Navbar />
    <main className={cn('flex-1', mainClassName)}>{children}</main>
    <Footer />
  </div>
);

export default PageLayout;
